import { render, staticRenderFns } from "./loRoot.vue?vue&type=template&id=5038c14b&scoped=true&"
import script from "./loRoot.vue?vue&type=script&lang=js&"
export * from "./loRoot.vue?vue&type=script&lang=js&"
import style0 from "./loRoot.vue?vue&type=style&index=0&id=5038c14b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5038c14b",
  null
  
)

export default component.exports